import React, { useState, useEffect } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { useParams } from 'react-router-dom';

import Alert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';

import Loading from 'app/components/loaders/Loading';
import EditEntryDialog from 'app/components/form/EditEntryDialog';

import useApi from 'app/context/useApi';

const useStyles = makeStyles(theme => ({
    container: {
        maxWidth: 400,
        margin: '24px auto',
        textAlign: 'center'
    },
    marginTop: {
        marginTop: theme.spacing(3)
    }
}));

export default function PublicForm (props) {

    const api = useApi();
    const classes = useStyles();
    const params = useParams();

    const [ form, setForm ] = useState(null);

    const [ formDialogOpen, setFormDialogOpen ] = useState(false);
    const [ success, setSuccess ] = useState(false);

    const [ errors, setErrors ] = useState({});
    const [ loading, setLoading ] = useState(false);

    const getForm = () => {

        api.get(`/form/${params.hash}`)
            .then(res => {
                setForm(res.form);
                setLoading(false);
                
            }).catch(error => {
                if (error?.response?.data?.errors) setErrors({...errors, general: error.response.data.errors});
                setLoading(false)
            });
    }

    useEffect(() => {
        getForm();
    }, []);

    useEffect(() => {
        if (form) openFormDialog();
    }, [form]);

    // General Functions ------------------------------------------

    const openFormDialog = () => {
        setSuccess(false);
        setFormDialogOpen(true);
    }

    const closeFormDialog = () => {
        setSuccess(true);
        setFormDialogOpen(false);
    }

    // Post Functions ------------------------------------------

    const hasErrors = key => {
        if (errors[key]) return true;
        return false;
    }

    const getErrorMessages = key => {
        if (hasErrors(key)) return errors[key];
        return "";
    }

    // Constants --------------------------------------

    return (
        <div className={classes.container}>
            <Loading isLoading={loading}/>
            {hasErrors('general') &&
                <Alert severity="error">{getErrorMessages('general')}</Alert>
            }
            {(success) &&
                <>
                    <Alert severity="success">You have successfully submitted your form.</Alert>
                    <Button
                        className={classes.marginTop}
                        variant="contained"
                        onClick={() => setFormDialogOpen(true)}
                        color="primary"
                        >
                        Make Another Entry
                    </Button>
                </>
            }
            {(form) &&
                <EditEntryDialog
                    id={0}
                    form={form}
                    open={formDialogOpen}
                    onSave={closeFormDialog}
                    hash={params.hash}
                />
            }
        </div>
    );
}